import React from 'react';

import './styles.css';

const Footer = () => {
    return (
        <footer>
            <p>Desenvolvido por <a href="https://www.linkedin.com/in/fvedoin/" target="_blank" rel="noopener noreferrer">Fernando Vedoin Garcia</a> e <a href="https://www.linkedin.com/in/felipe-cechin-mello/" target="_blank" rel="noopener noreferrer">Felipe Cechin Mello</a>.</p>
        </footer>
    );
};

export default Footer;